
import { Component, Vue, Prop } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import Swal from "sweetalert2";

@Component({})
export default class OTPVerificationComponent extends Vue {
  @Prop() public data;
  public otp = null;
  public disableSubmitbutton = false;

  public async validateAndSubmit() {
    let valid = await this.$validator.validateAll();
    if (valid) {
      this.disableSubmitbutton = true;
      this.$showLoader(true);
      let response = await Axios.post(
        API_STORE.SERVICE + this.data.serviceName,
        {
          otp: this.otp,
          mobileNumber: this.data.mobileNumber,
          state: this.data.state,
          beneId: this.data.beneId ? this.data.beneId : null,
        },
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.disableSubmitbutton = false;
      this.$showLoader(false);
      if (response) {
        if (!response.data.errorExist) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: true,
          });
          this.$emit("updateOTPVerification", {
            activeTabLinks: response.data.activeTabLinks,
            activeTab: response.data.activeTab,
            availAPICapacity: response.data.availAPICapacity
              ? response.data.availAPICapacity
              : null,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: response.data.message,
            showConfirmButton: true,
          });
          if (response.data.closeModal)
            this.$emit("updateOTPVerification", {
              activeTabLinks: response.data.activeTabLinks,
              activeTab: response.data.activeTab,
              availAPICapacity: null,
            });
        }
      }
    }
  }

  //Resend Otp
  public async resendOtp(){
    this.$showLoader(true);
    let response = await Axios.get(API_STORE.COMMON + 'resendDmtOtp/'+this.data.mobileNumber,{
      headers: getAPIAuthorizedHeader(),
    });
    Swal.fire({
      position: "center",
      icon: "success",
      title: response.data.message,
      showConfirmButton: true,
    });
    this.data.state = response.data.data.data.state
    this.$showLoader(false);
  }

  resetForm() {
    this.$emit("cancel", true);
  }
}
